import { useEffect } from 'react';

interface PageMeta {
  title: string;
  description: string;
  geo?: {
    placename: string; // e.g. "Seattle, Washington"
    lat: number;
    lon: number;
  };
}

function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.name = name;
    document.head.appendChild(tag);
  }
  tag.content = content;
}

function removeMeta(name: string) {
  document.querySelector(`meta[name="${name}"]`)?.remove();
}

export function usePageMeta(title: string, description: string, geo?: PageMeta['geo']) {
  useEffect(() => {
    document.title = title;
    setMeta('description', description);

    if (geo) {
      setMeta('geo.region', 'US-WA');
      setMeta('geo.placename', geo.placename);
      setMeta('geo.position', `${geo.lat};${geo.lon}`);
      setMeta('ICBM', `${geo.lat}, ${geo.lon}`);
    } else {
      // Remove city-level tags when navigating back to non-city pages
      removeMeta('geo.position');
      removeMeta('ICBM');
      // Keep geo.region and geo.placename at state level (set in index.html)
    }
  }, [title, description, geo?.placename, geo?.lat, geo?.lon]);
}
